import { render, staticRenderFns } from "./PriceInputWithCurrency.vue?vue&type=template&id=06b969b5&scoped=true&"
import script from "./PriceInputWithCurrency.vue?vue&type=script&lang=ts&"
export * from "./PriceInputWithCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./PriceInputWithCurrency.vue?vue&type=style&index=0&id=06b969b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b969b5",
  null
  
)

export default component.exports